import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Save } from "lucide-react";
import { api, formatApiError } from "../../api";

export default function AdminAccount() {
  const [account, setAccount] = useState({ username: "", email: "" });
  const [passwords, setPasswords] = useState({ current_password: "", new_password: "" });
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    (async () => {
      try {
        const { data } = await api.get("/api/admin/account");
        setAccount({ username: data.username || "", email: data.email || "" });
      } catch {}
    })();
  }, []);

  const saveAccount = async (e) => {
    e.preventDefault();
    setSaving(true);
    try {
      await api.put("/api/admin/account", { username: account.username, email: account.email });
      toast.success("Account updated");
    } catch (err) {
      toast.error(formatApiError(err));
    } finally {
      setSaving(false);
    }
  };

  const changePassword = async (e) => {
    e.preventDefault();
    try {
      await api.put("/api/admin/account", {
        current_password: passwords.current_password,
        new_password: passwords.new_password,
      });
      toast.success("Password updated");
      setPasswords({ current_password: "", new_password: "" });
    } catch (err) {
      toast.error(formatApiError(err));
    }
  };

  return (
    <div className="admin-page">
      <div className="admin-page-head">
        <div>
          <span className="eyebrow">Access</span>
          <h1>Admin account.</h1>
        </div>
      </div>

      <section className="admin-form-section">
        <h2>Profile</h2>
        <form onSubmit={saveAccount} className="form-grid">
          <label className="span-2">
            Username
            <input
              required
              value={account.username}
              onChange={(e) => setAccount({ ...account, username: e.target.value })}
              data-testid="admin-username-input"
            />
          </label>
          <label className="span-2">
            Email
            <input
              required
              type="email"
              value={account.email}
              onChange={(e) => setAccount({ ...account, email: e.target.value })}
              data-testid="admin-email-input"
            />
          </label>
          <button className="button dark-button span-2" type="submit" disabled={saving} data-testid="save-admin-profile">
            <Save size={14} /> {saving ? "Saving…" : "Save profile"}
          </button>
        </form>
      </section>

      <section className="admin-form-section">
        <h2>Change password</h2>
        <form onSubmit={changePassword} className="form-grid" style={{ maxWidth: 520 }}>
          <label className="span-2">
            Current password
            <input
              required
              type="password"
              value={passwords.current_password}
              onChange={(e) => setPasswords({ ...passwords, current_password: e.target.value })}
              data-testid="admin-current-password-input"
            />
          </label>
          <label className="span-2">
            New password (min 6 characters)
            <input
              required
              type="password"
              minLength={6}
              value={passwords.new_password}
              onChange={(e) => setPasswords({ ...passwords, new_password: e.target.value })}
              data-testid="admin-new-password-input"
            />
          </label>
          <button className="button dark-button span-2" type="submit" data-testid="admin-change-password-submit">
            Update password
          </button>
        </form>
      </section>
    </div>
  );
}
